var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContentCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 0.833313H3.33341C2.41675 0.833313 1.66675 1.58331 1.66675 2.49998V14.1666H3.33341V2.49998H13.3334V0.833313ZM15.8334 4.16665H6.66675C5.75008 4.16665 5.00008 4.91665 5.00008 5.83331V17.5C5.00008 18.4166 5.75008 19.1666 6.66675 19.1666H15.8334C16.7501 19.1666 17.5001 18.4166 17.5001 17.5V5.83331C17.5001 4.91665 16.7501 4.16665 15.8334 4.16665ZM15.8334 17.5H6.66675V5.83331H15.8334V17.5Z",
    fill: "#8E173E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentCopy);
export default __webpack_public_path__ + "static/media/content-copy.43d3cf78.svg";
export { ForwardRef as ReactComponent };